import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AccountList from "../components/Hybrid/account-list";
import AccountListWasabi from "../components/CloudProviders/account-list";
import LoadingSpinner from "../components/Shared/LoadingSpinner";
import EmptyState from "../components/Shared/EmptyState";
import {
  fetchCloudAccounts,
  new_fetch_clouds,
  new_fetch_buckets,
  expandCloudAccount,
  deleteCloudAccount
} from "../actions/cloud-accounts-actions";
import { Button } from "antd";
import "./styles.scss";

class CloudAccountListContainer extends React.Component {
  constructor(props) {
    super();
    this.state = {
      wasabi: null
    };
    this.handleExpandClick = this.handleExpandClick.bind(this);
    this.handleDeleteCAClick = this.handleDeleteCAClick.bind(this);
  }

  componentDidMount() {
    const { history } = this.props;
    let $this = this;
    
    this.props.new_fetch_clouds(clouds => {
      for (let key in clouds) {
        let cloud = clouds[key];
        // console.log("here cloud", cloud.id);
        let payload = {};
        payload.cloudAccountId = cloud.id;

        $this.props.new_fetch_buckets(payload);
      }
      if (clouds.length === 0) {
        // if the user has no cloud accounts
        history.push("/addProvider"); // redirect him to add provider page automatically
      }
    });
    // this.props.fetch_clouds(clouds => {
    //   for (let key in clouds) {
    //     let cloud = clouds[key];
    //     $this.props.fetch_buckets(cloud.id);
    //   }
    //   if (clouds.length === 0) {
    //     // if the user has no cloud accounts
    //     history.push("/addProvider"); // redirect him to add provider page automatically
    //   }
    // });
  }

  handleExpandClick(expandedItemId) {
    this.props.expandCloudAccount(expandedItemId);
  }

  handleDeleteCAClick(cloudAccountId) {
    this.props.deleteCloudAccount(cloudAccountId);
  }

  on_bucket_refresh = id => {
    if (id) return this.props.new_fetch_buckets(id);

    let $this = this;
    this.props.new_fetch_clouds(clouds => {
      for (let key in clouds) {
        let cloud = clouds[key];
        $this.props.new_fetch_buckets(cloud.id);
      }
    });
  };

  on_show_compare = cloud => {};

  render() {
    const { expandedItemId, loading, error, filter, history } = this.props;
    let { items, bucket_loading = false } = this.props;
    if (loading && items.length === 0) {
      return <LoadingSpinner />;
    }

    // if (error) {
    //   return <Alert message='Internal Server Error' type='error' showIcon
    //     style={{ width: '80%', margin: '80px auto' }}
    //     description='Oh no! Something bad happened. Please come back later when we fixed that problem. Thanks.'
    //   />
    // }
    if (!error && items.length === 0) {
      return (
        <div className="cloud-account-list">
          <div className="empty-list-msg">
            <h2>You currently have no cloud accounts connected to CloudFlyer.</h2>
            <h2>Please add one here:</h2>
            <Button onClick={() => history.push("/addProvider")}>
              Add Cloud Account
            </Button>
          </div>
        </div>
      );
    }
    return (
      items &&
      items.length > 0 && (
        // <AccountList
        //   items={items}
        //   filter={filter}
        //   expandedItemId={expandedItemId}
        //   history={history}
        //   bucket_refreshing={bucket_loading}
        //   on_show_compare={this.on_show_compare}
        //   handleExpandClick={this.handleExpandClick}
        //   handleDeleteCAClick={this.handleDeleteCAClick}
        //   on_bucket_refresh={this.on_bucket_refresh}
        // />
        <AccountListWasabi
          items={items}
          filter={filter}
          expandedItemId={expandedItemId}
          history={history}
          bucket_refreshing={bucket_loading}
          on_show_compare={this.on_show_compare}
          handleExpandClick={this.handleExpandClick}
          handleDeleteCAClick={this.handleDeleteCAClick}
          on_bucket_refresh={this.on_bucket_refresh}
        />
      )
    );
  }
}

const mapStateToProps = ({ cloudAccounts }) => cloudAccounts;

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchCloudAccounts,
      new_fetch_clouds,
      new_fetch_buckets,
      expandCloudAccount,
      deleteCloudAccount
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CloudAccountListContainer)
);
